if (!customElements.get('logout-redirect')){
    customElements.define('logout-redirect', class LogoutRedirect extends HTMLElement {
      constructor() {
        super();
    
        this.link = this.querySelector('a');
        this.LOGOUT_URL = '/account/logout';


        this.link.addEventListener('click', this.redirect.bind(this));
      }

      redirect(e){
        e.preventDefault();
        const redirect_url = this.link.getAttribute('href') ?? '/';

        fetch(this.LOGOUT_URL).then(() => window.location.href = redirect_url);
      }
    })
  }